module.exports = __webpack_public_path__ + "static/img/fc_xd.732a2d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fc_xd.png
// module id = fp3I
// module chunks = 18